import { useEffect } from 'react';
import { X, Maximize2, ChevronLeft, ChevronRight } from 'lucide-react';

export default function Drawer({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = 'md', // 'md' | 'lg'
  variant = 'default', // 'default' | 'hero'
  media = null,
  cover = null,
  coverContent = null,
  coverTop = null,
  onExpandCover = null,
  hasMultipleCovers = false,
  onPrevCover = null,
  onNextCover = null,
}) {
  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const isHero = variant === 'hero' && cover;

  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <div className={`drawer-panel drawer-panel--${size}${isHero ? ' drawer-panel--hero' : ''}`}>
        {isHero ? (
          <div className="drawer-panel__hero">
            {cover}
            <div className="drawer-panel__hero-scrim" />
            {onExpandCover && (
              <button
                type="button"
                className="drawer-panel__hero-expand"
                onClick={onExpandCover}
                aria-label="Perbesar gambar"
              >
                <Maximize2 size={16} />
              </button>
            )}
            <button
              type="button"
              className="drawer-panel__hero-close"
              onClick={onClose}
              aria-label="Tutup"
            >
              <X size={18} />
            </button>
            {hasMultipleCovers && onPrevCover && (
              <button
                type="button"
                className="drawer-panel__hero-nav drawer-panel__hero-nav--prev"
                onClick={onPrevCover}
                aria-label="Foto sebelumnya"
              >
                <ChevronLeft size={18} />
              </button>
            )}
            {hasMultipleCovers && onNextCover && (
              <button
                type="button"
                className="drawer-panel__hero-nav drawer-panel__hero-nav--next"
                onClick={onNextCover}
                aria-label="Foto selanjutnya"
              >
                <ChevronRight size={18} />
              </button>
            )}
            <div className="drawer-panel__hero-overlay">
              {coverTop && (
                <div className="drawer-panel__hero-top">{coverTop}</div>
              )}
              <div className="drawer-panel__hero-caption">
                {subtitle && <div className="drawer-panel__hero-subtitle">{subtitle}</div>}
                <h3 className="drawer-panel__hero-title">{title}</h3>
              </div>
              {coverContent && (
                <div className="drawer-panel__hero-content">{coverContent}</div>
              )}
            </div>
          </div>
        ) : (
          <div className="drawer-panel__header">
            <h3 className="drawer-panel__title">{title}</h3>
            <button className="modal-content__close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>
        )}
        <div className="drawer-panel__body">
          {media && <div className="drawer-panel__media">{media}</div>}
          {children}
        </div>
        {footer && <div className="drawer-panel__footer">{footer}</div>}
      </div>
    </>
  );
}
